import React from "react";


export class TopButtonBar extends React.Component {
    constructor(props) {
        super(props);

        this.logoutClicked = this.logoutClicked.bind(this);
        this.openSettingsClicked = this.openSettingsClicked.bind(this);
        this.downloadLogClicked = this.downloadLogClicked.bind(this);
    }

    logoutClicked() {
        window.app.logoutClicked();
    }

    openSettingsClicked() {
        window.app.openSettingsClicked();
    }

    downloadLogClicked() {
        window.app.downloadLog(window.app.logboek.id);
    }


    render() {

        return (<div className={"tool__topbuttonbar__wrapper"}>
            {this.props.show_logboek &&

                (<>
                    <a href="javascript:void(0);" onClick={this.downloadLogClicked}><img src={"/digibord/assets/svgs/logboek_btn.svg"} className="tool__topbuttonbar__logboek_btn" alt="Logboek downloaden"/></a>


                </>)

            }


            {this.props.show_logboek && this.props.loggedIn &&

                (<img src={"/digibord/assets/svgs/button_divider.svg"} className="tool__topbuttonbar___divider"
                      alt=""/>)

            }

            {this.props.loggedIn &&

                (<>
                    <a href="javascript:void(0);" onClick={this.openSettingsClicked}><img src={"/digibord/assets/svgs/instellingen_btn.svg"} className="tool__topbuttonbar__instellingen_btn" alt="Instellingen"/></a>
                    <img src={"/digibord/assets/svgs/button_divider.svg"} className="tool__topbuttonbar___divider" alt=""/>
                    <a href="javascript:void(0);" onClick={this.logoutClicked}><img src={"/digibord/assets/svgs/uitloggen_btn.svg"} className="tool__topbuttonbar__uitloggen_btn" alt="Uitloggen"/></a>

                </>)

            }


        </div>);
    }

}
